import { Avatar, AvatarFallback, AvatarImage } from './avatar';
import { cn } from '../../lib/utils';
import type { SenderPreview } from '../../types/climb';

interface AvatarStackProps {
  users: SenderPreview[];
  totalCount: number;
  max?: number;
  size?: 'sm' | 'md';
  className?: string;
}

export function AvatarStack({
  users,
  totalCount,
  max = 3,
  size = 'sm',
  className,
}: AvatarStackProps) {
  const visible = users.slice(0, max);
  const remaining = Math.max(0, totalCount - visible.length);

  const sizeClass = size === 'sm' ? 'h-7 w-7' : 'h-9 w-9';
  const textClass = size === 'sm' ? 'text-[10px]' : 'text-xs';

  if (visible.length === 0 && remaining === 0) {
    return null;
  }

  return (
    <div className={cn('flex items-center', className)}>
      {visible.map((user, idx) => (
        <Avatar
          key={user.id}
          className={cn(
            sizeClass,
            'ring-2 ring-background',
            idx > 0 && '-ml-2',
          )}
        >
          {user.avatar_small_url ? (
            <AvatarImage src={user.avatar_small_url} alt={user.username ?? ''} />
          ) : null}
          <AvatarFallback className={textClass}>
            {(user.username?.charAt(0) ?? '?').toUpperCase()}
          </AvatarFallback>
        </Avatar>
      ))}

      {remaining > 0 && (
        <div
          className={cn(
            sizeClass,
            'rounded-full bg-muted ring-2 ring-background flex items-center justify-center',
            textClass,
            'font-medium text-muted-foreground',
            visible.length > 0 && '-ml-2',
          )}
        >
          +{remaining}
        </div>
      )}
    </div>
  );
}
